import my_collection from "../lang/jp/mine/my-collection.js";

//商品详情
import productDetail from "../lang/jp/product/productDetail.js";
export default {
  my_collection: my_collection,
  productDetail: productDetail
};